import { useMemo } from 'react'
import { useRecoilValue } from 'recoil'
import { roleAtom } from '@/atoms/globalAtoms'
import { userAtom } from '@/atoms/_globalAtoms'
import { userTypes } from '@messenger/consts'

export const useIsAdmin = (): boolean => {
  const userRole = useRecoilValue(roleAtom)
  const user = useRecoilValue(userAtom)
  return useMemo(
    () =>
      userRole === 'messenger-user' ||
      user?.type === userTypes.superAdmin ||
      user?.type === userTypes.corporationAdmin ||
      !!user?.actAsAdmin,
    [userRole, user?.type, user?.actAsAdmin],
  )
}
